export const videos = [
  {
    id: "njahgbnsoqo",
    title: "real_estate_photos",
    thumbnail: "https://img.youtube.com/vi/njahgbnsoqo/maxresdefault.jpg",
    width: 480,
    height: 261,
  },
  {
    id: "RIu-iotACuU",
    title: "lodging_photography",
    thumbnail: "https://img.youtube.com/vi/RIu-iotACuU/maxresdefault.jpg",
    width: 480,
    height: 318,
  },
  {
    id: "gzNCeSxHx9Q",
    title: "project_photo_branding",
    thumbnail: "https://img.youtube.com/vi/gzNCeSxHx9Q/maxresdefault.jpg",
    width: 480,
    height: 318,
  },
  {
    id: "aA41F_OgHgE",
    title: "construction_docs_monitoring",
    thumbnail: "https://img.youtube.com/vi/aA41F_OgHgE/maxresdefault.jpg",
    width: 600,
    height: 319,
  },
  {
    id: "b3b3uYyEtME",
    title: "car_lot_aerials",
    thumbnail: "https://img.youtube.com/vi/b3b3uYyEtME/maxresdefault.jpg",
    width: 600,
    height: 319,
  },
  {
    id: "h_3DgHJ7Hj0",
    title: "real_estate_photos",
    thumbnail: "https://img.youtube.com/vi/h_3DgHJ7Hj0/maxresdefault.jpg",
    width: 480,
    height: 319,
  },
  {
    id: "Uf1EhdiUpT8",
    title: "real_estate_photos",
    thumbnail: "https://img.youtube.com/vi/Uf1EhdiUpT8/maxresdefault.jpg",
    width: 480,
    height: 319,
  },
  {
    id: "JAlZz-cRhgo",
    title: "real_estate_photos",
    thumbnail: "https://img.youtube.com/vi/JAlZz-cRhgo/maxresdefault.jpg",
    width: 480,
    height: 319,
  },
  {
    id: "5LQXf-N4zvM",
    title: "construction_docs_monitoring",
    thumbnail: "https://img.youtube.com/vi/5LQXf-N4zvM/maxresdefault.jpg",
    width: 480,
    height: 319,
  },
  {
    id: "P7TQ2ynRpIM",
    title: "real_estate_photos",
    thumbnail: "https://img.youtube.com/vi/P7TQ2ynRpIM/maxresdefault.jpg",
    width: 600,
    height: 319,
  },
  {
    id: "LxFTftLgLog",
    title: "lodging_photography",
    thumbnail: "https://img.youtube.com/vi/LxFTftLgLog/maxresdefault.jpg",
    width: 600,
    height: 319,
  },
];
